<template>
  <n-config-provider :theme-overrides="themeOverrides">
    <n-message-provider>
      <n-dialog-provider>
        <router-view />
        <PwaInstallPrompt />
      </n-dialog-provider>
    </n-message-provider>
  </n-config-provider>
</template>

<script setup lang="ts">
import { NConfigProvider, NMessageProvider, NDialogProvider } from 'naive-ui'
import type { GlobalThemeOverrides } from 'naive-ui'
import PwaInstallPrompt from 'src/components/PwaInstallPrompt.vue'

const themeOverrides: GlobalThemeOverrides = {
  common: {
    primaryColor: '#0058be',
    primaryColorHover: '#0047a0',
    primaryColorPressed: '#003880',
    primaryColorSuppl: '#0058be',
  },
  Button: {
    fontWeightStrong: '600',
  },
}
</script>
